<template>
  <div class="about">
    <div class="twdiv">
      <img src="../../assets/images/leftF.png" class="leftF" />
      <img src="../../assets/images/about.png" class="imgtitle" />
      <img src="../../assets/images/rightF.png" class="rightF" />
      <div class="list">
        <img class="about_logo" src="../../assets/images/qrcode.png" />
        <div class="textdiv">
          <span v-html="filterXSS(aboutOnece.content)"></span>
          <!-- Negative carbon emissions are considered to be a promising approach to
          the goal of the Paris Agreement to limit global warming to 2.0°C or
          perhaps even 1.5°C by the end of this century. The ocean has a large
          capacity to sequester carbon and has absorbed approximately 25% of the
          CO₂ produced by fossil fuel combustion and cement production since the
          beginning of the industrial revolution. Increasing ocean carbon sinks
          by anthropogenic processes (or ocean negative carbon emissions, ONCE)
          has the potential to contribute to carbon neutrality if the mechanisms
          and processes involved are properly understood.-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { filterXSS } from '../../utils/xss';
export default {
  name: 'AboutUs',
  data() {
    return {
      aboutOnece: []
    };
  },
  mounted() {
    this.getAbout();
  },
  methods: {
    filterXSS,
    getAbout() {
      let ucode = '410e03b62f1940e4be4ddba25c4b7cc5';
      let url = `${window._CONFIG['domianURL']}xmu/index/getData/${ucode}?column=id&order=desc&pageNo=1&pageSize=999&superQueryMatchType=and`;
      this.$axios({
        method: 'get',
        url: url
      }).then(res => {
        let data = res.data.result.records[0];
        this.aboutOnece = data;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.about {
  width: 100%;
  height: 300px;
  position: relative;
  margin-bottom: 10px;

  .about_logo {
    width: 325px;
    height: 325px;
    margin-left: 82px;
    object-fit: contain;
  }

  .twdiv {
    margin-top: 70px;
    padding-top: 10px;
    z-index: 50;
    position: absolute;
    left: 0;
    // top: -395px;
    top: 30px;
    width: 100%;
    // height: 100vh;
    // background-image: url("./hximg.png");
    background-size: 100%;
    background-position: center !important;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .list {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .imgtitle {
    width: 422px;
    height: 80px;
    margin-bottom: 20px;
  }
}
.textdiv {
  width: 55% !important;
  line-height: 40px;
  font-size: 22px;
  color: #000;
  font-family: 'pala';
}
.leftF {
  position: absolute;
  width: 200px;
  z-index: -2;
  left: -53px;
  top: -185px;
  height: 555px;
}

.rightF {
  position: absolute;
  width: 145px;
  height: 538px;
  z-index: -2;
  top: -185px;
  right: -2px;
}
</style>
